import * as type from '../actions/types';

const initialState = {
  data: [],
  error: '',
  pending: false,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.REQUEST_OFFER_EDIT_PENDING:
      return {
        ...state,
        pending: true,
        error: '',
      };
    case type.REQUEST_OFFER_EDIT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        pending: false,
        success: true,
      };
    case type.REQUEST_OFFER_EDIT_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
